import { useState } from 'react';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';

interface ReviewFiltersProps {
  onSearch: (productId?: number) => void;
}

export const ReviewFilters = ({ onSearch }: ReviewFiltersProps) => {
  const [productId, setProductId] = useState('');

  const handleSearch = () => {
    if (productId.trim()) {
      const productIdNumber = Number(productId.trim());
      if (!isNaN(productIdNumber)) {
        onSearch(productIdNumber);
      } else {
        console.error('Invalid Product ID entered');
      }
    } else {
      // If no productId, search all reviews
      onSearch();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClear = () => {
    setProductId('');
    onSearch(); // Search all reviews when cleared
  };

  return (
    <Row className="mb-4">
      <Col>
        <div className="bg-light p-3 rounded">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group>
                <Form.Select value="productId" disabled>
                  <option value="productId">Product ID</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={7}>
              <Form.Group>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Enter Product ID (searches all statuses: Submitted, Published, Curated)..."
                    value={productId}
                    onChange={(e) => setProductId(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                  {productId && (
                    <Button variant="outline-secondary" onClick={handleClear}>
                      ✕
                    </Button>
                  )}
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};
